<template>
  <div>
    <details-modal
      :show="show"
      :current-operation="currentOperation"
      @close="closeModal"
      @cancel="closeModal"
      @create="createAddressButtonClicked"
      @delete="deleteAddressButtonClicked"
      @update="updateAddressButtonClicked"
    >
      <form class="text-left">
        <address-type-select
          v-validate="'required'"
          v-if="type === personType"
          v-model="address.addrTypeId"
          :disabled="currentOperation == 'edit'"
          data-vv-scope="formAddressDetails"
          name="type d'adresse"
          required
          title="Type d'adresse *"
        />
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formAddressDetails.type d'adresse`) }}
        </div>
        <label>Rue/Case Postale</label>
        <div class="row">
          <div class="form-group form-address-street">
            <div class="col-md-12">
              <textarea
                v-model="address.addrStreet"
                class="form-control"
                rows="2"
                type="text"
                name="Rue/Case Postale"
              />
            </div>
          </div>
        </div>
        <fg-input
          v-model="address.addrPostalno"
          type="text"
          label="Numéro Postal"
        />
        <fg-input
          v-validate="'required'"
          v-model="address.addrCity"
          data-vv-scope="formAddressDetails"
          name="ville"
          required
          type="text"
          label="Ville"
        />
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first('formAddressDetails.ville') }}
        </div>
        <canton-select v-model="address.addrCantonCode" />
        <country-select
          v-validate="'required'"
          v-model="address.addrCountryId"
          data-vv-scope="formAddressDetails"
          name="pays"
          label="Pays *"
          required
        />
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first('formAddressDetails.pays') }}
        </div>
        <default-select
          v-validate="'required'"
          v-model="address.addrDefault"
          title="Défaut *"
          data-vv-scope="formAddressDetails"
          name="défaut"
          required
        />
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first('formAddressDetails.défaut') }}
        </div>
        <p class="mt-3 mb-0"><label>* champs obligatoires</label></p>
      </form>
      <p v-if="errorMessage" class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import AddressTypeSelect from 'src/components/ApplicationViews/UIComponents/AddressTypeSelect';
import CantonSelect from 'src/components/ApplicationViews/UIComponents/CantonSelect';
import CountrySelect from 'src/components/ApplicationViews/UIComponents/CountrySelect';
import DefaultSelect from 'src/components/ApplicationViews/UIComponents/DefaultSelect';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    AddressTypeSelect,
    CantonSelect,
    CountrySelect,
    DefaultSelect,
    DetailsModal,
  },
  props: {
    show: Boolean,
    currentOperation: String,
    address: Object,
    linkedEntityId: Number,
    // Either "people" or "institutions", will change the URIs and show/hide the "type" field.
    type: String,
  },
  data() {
    return {
      personType: 'people',
      errorMessage: '',
    };
  },
  methods: {
    createAddressButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formAddressDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          const data = {
            ...this.address,
          };

          if (this.type === this.personType) {
            data.personId = this.linkedEntityId;
          } else {
            data.institutionId = this.linkedEntityId;
          }

          this.$http
            .post(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/addresses/`,
              data,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response.status === 409) {
                this.errorMessage =
                  'La personne possède déjà une adresse de ce type.';
              } else {
                this.errorMessage =
                  "Une erreur est survenue lors de l'ajout de l'adresse, veuillez réessayer ou contacter le support.";
              }
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    updateAddressButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formAddressDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          const data = {
            ...this.address,
          };

          if (this.type === this.personType) {
            data.personId = this.linkedEntityId;
          } else {
            data.institutionId = this.linkedEntityId;
          }

          this.$http
            .patch(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/addresses/${this.address.id}`,
              data,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response.status === 409) {
                this.errorMessage =
                  'La personne possède déjà une adresse de ce type.';
              } else {
                this.errorMessage =
                  "Une erreur est survenue lors de l'édition de l'adresse, veuillez réessayer ou contacter le support.";
              }
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    deleteAddressButtonClicked() {
      this.errorMessage = null;

      swal({
        title: 'Êtes-vous sûr de vouloir supprimer cette adresse ?',
        text: "Il ne sera pas possible d'annuler cette suppression",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      })
        .then(() => {
          this.$http
            .delete(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/addresses/${this.address.id}`,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response && error.response.data.errors.length > 0) {
                this.errorMessage = error.response.data.errors[0];
              } else {
                this.errorMessage =
                  "Une erreur est survenue lors de la suppression de l'adresse, veuillez réessayer ou contacter le support.";
              }
            });
        })
        .catch(() => {});
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.validation-error {
  color: red;
  margin-bottom: 1em;
}
</style>
